import * as P from 'plow-js';
import { createReducer } from 'redux-act';
// centralized-dispatch
import * as A from './actions';
//////////////////////////////////////////////////

const initialState = {
  reports: [],
  usedReport: null,
  tripsOrderFields: [],
  tripsSearchCriteria: [],
  driversSearchCriteria: [],
  driversRadiusRequestParams: {},
};

const setReports = (state, reports) => (
  P.$set('reports', reports, state)
);

const setUsedReport = (state, report) => (
  P.$set('usedReport', report, state)
);

const setTripsSearchCriteria = (state, searchCriteria) => (
  P.$set('tripsSearchCriteria', searchCriteria, state)
);

const setTripsOrderFields = (state, orderFields) => (
  P.$set('tripsOrderFields', orderFields, state)
);

const setDriversSearchCriteria = (state, searchCriteria) => (
  P.$set('driversSearchCriteria', searchCriteria, state)
);

const setDriversRadiusRequestParams = (state, requestParams) => (
  P.$set('driversRadiusRequestParams', requestParams, state)
);

export default createReducer({
  [A.setReports]: setReports,
  [A.setUsedReport]: setUsedReport,
  [A.setTripsOrderFields]: setTripsOrderFields,
  [A.setTripsSearchCriteria]: setTripsSearchCriteria,
  [A.setDriversSearchCriteria]: setDriversSearchCriteria,
  [A.setDriversRadiusRequestParams]: setDriversRadiusRequestParams,
}, initialState);
